import React, { useContext, useState } from "react";
import Header from "../../components/Header";
import Title from "../../components/Title";
import '../Dashboard/dashboard.css';
import { ref, uploadBytes, getDownloadURL } from "@firebase/storage";
import { addDoc, collection } from "@firebase/firestore";
import { db, storage } from '../../services/firebaseConnection';
import { toast } from "react-toastify";
import { AuthContext } from "../../contexts/auth";
import { FiPlus, FiUpload, FiTrash2 } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Customers() {
    const { user } = useContext(AuthContext);

    const [images, setImages] = useState([]);
    const [titulo, setTitulo] = useState('');
    const [descricao, setDescricao] = useState('');
    const [endereco, setEndereco] = useState('');
    const [suggestions, setSuggestions] = useState([]); 
    const [xpAtual, setXpAtual] = useState(0);
    const [nivel, setNivel] = useState(1);
    const { getGame, atualizarXP } = useContext(AuthContext);

    async function handleFile(e) { 
        
        const fileArray = Array.from(e.target.files);
        const validImages = fileArray.filter((image) =>
            image.type === 'image/jpeg' || image.type === 'image/png'
        );

        if (validImages.length !== fileArray.length) {
            toast.error("Envie imagens do tipo PNG ou JPEG");
        }

        setImages([...images, ...validImages]);
    }

    function handleRemoveImage(index) {
        setImages(images.filter((_, i) => i !== index));
    }

    async function handleRegister(e) {
        e.preventDefault();
    
        if (!user || !user.user_id) {
            toast.error("Usuário não autenticado. Por favor, faça login novamente.");
            console.error("User authentication error: user or user.user_id is undefined");
            return;
        }
    
        if (titulo !== '' && descricao !== '' && endereco !== '') {
            
            const gameData = await getGame(user.user_id);
            const xpAtualizado = gameData?.xp ?? 0;
            setXpAtual(xpAtualizado);
            setNivel(gameData?.nivel ?? 1);
    
            const promises = images.map(async (image) => {
                const storageRef = ref(storage, `images/${user.user_id}/${image.name}`);
                await uploadBytes(storageRef, image);
                const downloadURL = await getDownloadURL(storageRef);
                return downloadURL;
            });
    
            Promise.all(promises)
                .then((downloadURLs) => {
                    return addDoc(collection(db, "posts"), {
                        titulo: titulo,
                        descricao: descricao,
                        endereco: endereco,
                        userId: user.user_id,
                        images: downloadURLs,
                        created: new Date(),
                    });
                })
                .then(() => {
                    setTitulo('');
                    setDescricao('');
                    setEndereco('');
                    setImages([]);
                    adicionarXP(images, xpAtualizado);  
                    toast.success("Post registrado!");
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Erro ao realizar o cadastro.");
                });
        } else {
            toast.error("Preencha todos os campos!");
        }
    }
    
    const xpParaProximoNivel = (nivel) => {
        return 150 * nivel;
    };

    const adicionarXP = (images, xpAtualizado) => {
        
            let xpGanho = 50;
            if (images.length > 0) xpGanho += 10;
        
            let novoXP = xpAtualizado + xpGanho;
            let novoNivel = nivel;
        
            while (novoXP >= xpParaProximoNivel(novoNivel)) {
                novoNivel += 1; 
            }
        
            setXpAtual(novoXP);
            setNivel(novoNivel);
        
            
            atualizarXP(user.user_id, novoXP, novoNivel);
        
    };
    
    
    async function fetchAddressSuggestions(query) {
        const token = "pk.91417bff8835d2e2ef3bf8203a0ebcec"; 
        const url = `https://api.locationiq.com/v1/autocomplete.php?key=${token}&q=${query}&accept-language=pt`;

        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Erro ao buscar sugestões: ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Erro ao buscar sugestões de endereço:", error);
            return [];
        }
    }

    async function handleAddressChange(e) {
        setEndereco(e.target.value);
        if (e.target.value.length > 2) {
            const data = await fetchAddressSuggestions(e.target.value);
            setSuggestions(Array.isArray(data) ? data : []); 
        } else {
            setSuggestions([]); 
        }
    }

    function handleSuggestionClick(suggestion) {
        setEndereco(suggestion.display_name); 
        setSuggestions([]);
    }

    return (
        <div>
            <Header />
            <div className="content">
                <Title name="Criar Post">
                    <FiPlus size={25} />
                </Title>
                <div className="container">
                    <form className="formProfile" onSubmit={handleRegister}>
                        <br />
                        <label>Título:</label>
                        <input
                            type="text"
                            placeholder="Digite o título"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                        />
                        <label className="labelAvatar">
                            <br />
                            <div className="uploadContainer">
                                <FiUpload color="#000" size={25} />
                                <label>Selecione a imagem do computador</label>
                                <input style={{ display: 'none' }} type="file" accept="image/*" multiple onChange={handleFile} />
                            </div>
                            <br />
                            <div className="imagePreview">
                                {images.map((image, index) => (
                                    <div key={index} className="imageContainer">
                                        <img src={URL.createObjectURL(image)} alt={`Imagem ${index + 1}`} />
                                        <button type="button" onClick={() => handleRemoveImage(index)} className="removeButton">
                                            <FiTrash2 size={20} color="#ff0000" />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </label>
                        <label>Descrição:</label>
                        <textarea
                            style={{ resize: 'none', height: '150px' }}
                            type="text"
                            placeholder="Digite a descrição"
                            value={descricao}
                            className="textarea"
                            onChange={(e) => setDescricao(e.target.value)}
                        />
                        <label>Endereço:</label>
                        <input
                            type="text"
                            placeholder="Digite o endereço"
                            value={endereco}
                            onChange={handleAddressChange}
                        />
                        
                        <ul className="suggestions">
                            {suggestions.length > 0 && suggestions.map((suggestion, index) => (
                                <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                    {suggestion.display_name}
                                </li>
                            ))}
                        </ul>
                        <br />
                        <button type="submit" id="button">
                            Enviar
                        </button>
                        <br />
                    </form>
                </div>
            </div>
        </div>
    );
}
